import React from 'react';
import { Box, Typography } from '@mui/material';

import { finishInsertingCeilingTray } from '../../../../store/actions/layout/ceilingTrayActions';
import {
  isInsertionCeilingTrayFullyDefined,
  updateInsertingCeilingTray,
} from '../../../../store/slices/applicationSlice';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { CeilingTrayPropertyControls } from '../properties/roof-planes/CeilingTrayPropertyControls';
import InsertionPanelContainer from './InsertionPanelContainer';

export function CeilingTrayInsertionSubPanel() {
  const dispatch = useAppDispatch();

  const insertingObjectInfo = useAppSelector((state) => state.application.insertingObjectInfo);
  if (insertingObjectInfo?.type !== 'ceilingTray') return null;

  const tray = insertingObjectInfo.data;
  const disabled = !isInsertionCeilingTrayFullyDefined(tray);

  return (
    <InsertionPanelContainer
      disabled={disabled}
      onInsert={() => {
        dispatch(finishInsertingCeilingTray());
      }}
    >
      <Box sx={{ p: 1, mb: 2 }} className="clickable-during-picking">
        <Typography align="center" variant="h5" sx={{ marginBottom: 3 }}>
          Ceiling Tray Creation
        </Typography>

        <CeilingTrayPropertyControls tray={tray} onChange={(patch) => dispatch(updateInsertingCeilingTray(patch))} />
      </Box>
    </InsertionPanelContainer>
  );
}
